import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./editor.css";

import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Paper,
  Select,
} from "@material-ui/core";
import { ContentState, EditorState, convertToRaw } from "draft-js";
import { useEffect, useState } from "react";

import CustomAlert from "../../../components/CustomAlert";
import CustomDialog from "../../../components/CustomDialog";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import { fetchReferralPdf } from "../../../../services/referralKindsService";
import htmlToDraft from "html-to-draftjs";
import htmlToPdfmake from "html-to-pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfMake from "pdfmake";
import useLocale from "../../../../hooks/useLocale";
import {
  parseHtmlStringForEditor,
  parseHtmlStringForPdf,
} from "../../../../utils/parseHtmlString";

const useStyles = makeStyles((theme) => ({
  dialog: {
    height: 600,
    width: 600,
  },
  uploadButton: {
    marginBottom: 10,
    marginTop: 20,
  },
  DialogFill: {
    overflow: "hidden",
    paddingBottom: 0,
  },
  container: {
    height: "50rem",
    width: "100%",
  },
  description: {
    height: "1rem",
    marginBottom: "0.5rem",
  },
  itemContainer: {
    height: "20rem",
    margin: "2.5rem 0 0.5rem 0",
  },
  itemContainerPaper: {
    height: "100%",
  },
  wrapperEditor: {
    height: "90%",
    [theme.breakpoints.down("lg")]: {
      height: "65%",
    },
    padding: "0.1rem",
  },

  parameters: {
    height: "10rem",
    [theme.breakpoints.down("lg")]: {
      margin: "0.5rem 0 2rem 0",
    },
  },
  parametersPaper: {
    height: "90%",
    marginTop: "0.2rem",
  },
  parametersBox: {
    height: "100%",
    padding: "0.5rem",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      backgroundColor: "#fff",
      width: "16px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#fff",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#babac0",
      borderRadius: "16px",
      border: "4px solid #fff",
    },
    "&::-webkit-scrollbar-button": {
      display: "none",
    },
  },
  insertButton: {
    margin: "0.25rem",
    fontSize: "0.8rem",
  },
}));

const CreateReferralPdfDialog = ({
  open,
  close,
  refKindId,
  id,
  flowId,
  applicationKindId,
  pictureSrc,
  urlImageApplicant,
  urlFlag,
}) => {
  const classes = useStyles();
  const [error, setError] = useState("");
  const { t } = useLocale();
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [referralsToCreate, setReferralsToCreate] = useState();

  // const blob = newBlob([pictureSrc],type:"image/png")
  const getReferralHtmlAndSetState = async (
    applicationId,
    flowId,
    applicationKindId,
    urlImageApplicant,
    urlFlag
  ) => {
    try {
      const res = await fetchReferralPdf(
        applicationId,
        flowId,
        applicationKindId,
        urlImageApplicant
      );

      const data = parseHtmlStringForEditor(res, urlImageApplicant, urlFlag);

      setReferralsToCreate(data);
      // if (res) {
      //   const contentBlock = htmlToDraft(res);
      //   if (contentBlock) {
      //     const contentState = ContentState.createFromBlockArray(
      //       contentBlock.contentBlocks
      //     );
      //     const editorState = EditorState.createWithContent(contentState);
      //     setEditorState(editorState);
      //   }
      // }
    } catch (error) {
      setError(t("A network error occured, please try again later"));
      console.error(error);
    }
  };

  useEffect(() => {
    getReferralHtmlAndSetState(
      id,
      flowId,
      applicationKindId,
      urlImageApplicant,
      urlFlag
    );
  }, [refKindId, id]);

  const createPdfFromHtml = () => {
    //html to pdf format

    var html =
      // htmlToPdfmake(
      draftToHtml(convertToRaw(editorState?.getCurrentContent()));
    // );

    // const html1 = draftToHtml(convertToRaw(editorState?.getCurrentContent()));

    const { data } = parseHtmlStringForPdf(html, pictureSrc);
    const htmlforPdf = htmlToPdfmake(data);

    const documentDefinition = {
      content: htmlforPdf,
      pageMargins: [40, 60, 40, 60],
      defaultStyle: {
        font: "Roboto",
      },
    };
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    pdfMake.createPdf(documentDefinition).open();
  };

  return (
    <CustomDialog
      open={open}
      maxWidth="lg"
      onClose={() => {
        close();
        setEditorState();
        setError("");
      }}
    >
      <CustomAlert
        open={!!error}
        close={() => {
          setError("");
        }}
        message={t("A network error occured, please try again later")}
      />
      <DialogTitle id="form-dialog-title">
        {t("Referrals creation")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t(
            "Pick what kind of referral file you want to create, choose from dropdown which referral to show"
          )}
        </DialogContentText>
      </DialogContent>
      <DialogContent>
        <FormControl>
          <InputLabel id="referral">{t("Referral")}</InputLabel>
          <Select
            style={{ width: 350 }}
            labelId="referral"
            id="referral"
            onChange={(e) => {
              const contentBlock = htmlToDraft(e.target.value);

              if (contentBlock) {
                const contentState = ContentState.createFromBlockArray(
                  contentBlock.contentBlocks
                );
                const editorState = EditorState.createWithContent(contentState);

                setEditorState(editorState);
              }
            }}
          >
            {referralsToCreate?.map((ref) => (
              <MenuItem key={ref?.dscr} value={ref?.html}>
                {ref.dscr}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogContent>
        <Grid container direction="column">
          <Grid item className={classes.itemContainer}>
            <Paper className={classes.itemContainerPaper}>
              <Editor
                toolbar={{
                  fontFamily: {
                    options: ["Roboto"],
                    className: undefined,
                    component: undefined,
                    dropdownClassName: undefined,
                  },
                  image: {
                    uploadCallback: pictureSrc,
                    previewImage: true,
                  },
                }}
                toolbarClassName="toolbarClassName"
                wrapperClassName={classes.wrapperEditor}
                editorClassName="editorWrapper"
                editorState={editorState}
                onEditorStateChange={(newState) => {
                  setEditorState(newState);
                }}
              />
            </Paper>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={createPdfFromHtml} color="primary">
          {t("Create")}
        </Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default CreateReferralPdfDialog;
